module.exports = __webpack_public_path__ + "static/media/132.f0350c46.png";